export function getView(status, is_default) {
  return status === 'active' && is_default !== true
}
